export default "__VITE_ASSET__00Hgn8kr__"